import { Component, OnInit } from "@angular/core";
import { RouterModule, Router } from "@angular/router";
//import { MyserviceService } from './../myservice.service';
import { HttpClient, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { ApiCallingService } from "../services/api-calling.service";
import { Constants } from "../common/constants";
import { ConfigApi } from "../config-api";
//import { NgxLoadingModule } from 'ngx-loading';
import { Globals } from "../common/global";

import { SocketService } from "../services/socket.service";
// import { RouteAccessService } from "src/app/services/route-access.service";
import { EMPLOYEE_ROUTES } from "../shared/sidebar/employee-menu-item";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  providers: [ApiCallingService],
})
export class LoginComponent {
  msg = "";
  connectionID: any = "";
  QRcode: any;
  user: any;
  allcountries: any;
  constructor(
    public routes: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private apiCallingService: ApiCallingService,
    public globals: Globals,
    private SocketService: SocketService // private routeService: RouteAccessService
  ) {
    this.apiCallingService
      .callAPI({}, "GET", "assets/countries.json")
      .subscribe((data) => {
        this.allcountries = data;
      });
  }

  ngOnInit() {
    this.SocketService.getConnection().subscribe((data) => {
      this.QRcode = data;
      this.QRcode = `CL:${this.QRcode?.socket_id}`;
      console.log(
        "🚀 ~ file: login.component.ts:45 ~ LoginComponent ~ this.SocketService.getConnection ~ this.QRcode:",
        this.QRcode
      );
    });

    this.SocketService.getLogin().subscribe((data) => {
      this.user = data;
      this.apiCallingService
        .callAPI(
          {},
          "GET",
          ConfigApi.URLS.MY_PROFILE.GET_DETAIL +
            "/" +
            this.user.user_info.user_id._id
        )
        .subscribe((res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.globals.setUser(res.data);
            localStorage.setItem("is_loginEmployee", "false");

            if (res?.data?.business_detail) {
              let detail = this.allcountries.find((c: any) => {
                return res?.data?.business_detail?.country == c?.name;
              });
              if (detail?.currencies.length > 0) {
                localStorage.setItem("CUR", detail?.currencies[0]?.code);
              } else {
                let cur =
                  this.globals.getUser().stripe_account_detail
                    ?.default_currency;
                localStorage.setItem("CUR", cur?.toUpperCase());
              }

              if (localStorage.getItem("PENDING_PAYMENT")) {
                localStorage.removeItem("PENDING_PAYMENT");
              }

              if (res?.data?.business_detail?.isPluddaEnabled) {
                localStorage.setItem(
                  "isPluddaEnabled",
                  "" + res.data.business_detail &&
                    res.data.business_detail.isPluddaEnabled
                    ? res.data.business_detail.isPluddaEnabled
                    : false
                );
              } else {
                localStorage.setItem("isPluddaEnabled", "" + false);
              }
            }
            console.log(
              "res.data.flags.is_assets_registeredres.data.flags.is_assets_registered",
              res.data.flags.is_assets_registered
            );

            if (res.data.flags.is_assets_registered) {
              this.routes.navigate(["/user/dashboard"]);
            } else {
              this.routes.navigate(["/user/assets"]);
            }
          }
        });
    });
  }

  loginform = true;
  recoverform = false;
  employeeLogin = false;
  // showRecoverForm() {
  //   this.loginform = !this.loginform;
  //   this.recoverform = !this.recoverform;
  // }

  check(useremail: string, password: string) {
    const body = new HttpParams()
      .set(Constants.LOGIN_PRAMETER.KEY_API_EMAIL, useremail)
      .set(Constants.LOGIN_PRAMETER.KEY_API_PASSWORD, password);
    console.log("body", body);

    this.apiCallingService
      .callAPI(body, "POST", ConfigApi.URLS.EMPLOYEE.LOGIN)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            const userData = { ...res.data };

            if (!userData.flags) {
              userData.flags = {};
            }
            userData.flags.is_assets_registered = userData.is_assets_registered;

            if (userData.operator_id && userData.operator_id._id) {
              userData.employee_id = userData._id;
              userData._id = userData.operator_id._id;
            }
            console.log("UserData : ", userData);

            if (userData.permissions && userData.permissions.length > 0) {
              this.globals.setUser(userData);
              localStorage.setItem("is_loginEmployee", "true");
              localStorage.setItem("Auth-user", JSON.stringify(userData));
              console.log(
                " is_loginEmployee : ",
                localStorage.getItem("is_loginEmployee")
              );
              const findRouteByModule = (routes: any[], module: string) => {
                for (const route of routes) {
                  if (route.module === module) {
                    return route;
                  }
                  if (route.submenu && route.submenu.length > 0) {
                    const foundInSubmenu = route.submenu.find(
                      (subItem: any) => subItem.module === module
                    );
                    if (foundInSubmenu) {
                      return foundInSubmenu;
                    }
                  }
                }
                return null;
              };
              const myAssetRouteItem = findRouteByModule(
                EMPLOYEE_ROUTES,
                userData.permissions[0]["module"]
              );

              if (myAssetRouteItem) {
                this.routes.navigate(["/user/employee-dashboard"]);
                this.toastr.success(res?.msg);
              } else {
                this.toastr.error(
                  "You don't have enough permission to access cloud panel",
                  "Error"
                );
              }
            } else {
              // Throw Error
              // this.msg = res.msg;
              this.toastr.error(
                "You don't have enough permission to access cloud panel",
                "Error"
              );
            }

            // if (userData.role === "admin") {
            //   this.routes.navigate(["/user/dashboard"]);
            // }
          } else {
            this.msg = res.msg;
            this.toastr.error(this.msg || "Error", "Error");
          }
        },
        (error) => {
          this.msg = error.error?.msg;
          this.toastr.error(this.msg || "Error", "Error");
        }
      );
  }
}
